export default __webpack_public_path__ + "static/media/14.a73bf3fc.jpg";